import React from "react";
import { Link } from "react-router-dom";

function BlogsDetailsSidebar({ category }) {
  return (
    <div>
      <h3>Categories</h3>
      <ul>
        {Array.isArray(category) ? (
          category.map((cat, i) => (
            <li key={i}>
              <Link to={`/blogs/category/${cat.category_slug}`}>
                {cat.category_name}
              </Link>
            </li>
          ))
        ) : category?.category_name ? (
          <li>
            <Link to={`/blogs/category/${category.category_slug}`}>
              {category.category_name}
            </Link>
          </li>
        ) : (
          <li>No categories</li>
        )}
      </ul>
    </div>
  );
}

export default BlogsDetailsSidebar;
